import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

export type LanguageOption = {
  id: string;
  title: string;
  img_icon?: string;
};

@Component({
  selector: 'app-modal-change-language',
  templateUrl: './modal-change-language.component.html',
  styleUrls: ['./modal-change-language.component.scss'],
})
export class ModalChangeLanguageComponent implements OnInit {
  @Input() currentLanguage: LanguageOption;

  language_options: LanguageOption[] = [
    {
      id: 'en-US',
      title: 'English (US)',
      img_icon: '../../../assets/icon/usa-flag.png',
    },
    {
      id: 'id-ID',
      title: 'Bahasa Indonesia',
      img_icon: '../../../assets/icon/indonesia-flag.png',
    },
  ];

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    if (!this.currentLanguage) {
      this.currentLanguage = this.language_options[1];
    }
  }

  onSelectLanguage(selectedLanguage: LanguageOption) {
    this.modalController.dismiss(selectedLanguage, 'confirm');
  }

  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }
}
